import { createAction } from 'redux-actions';

const PREFIX = 'COLLECTION';

export const getCollections = createAction(`${PREFIX}/get`);
export const setCollections = createAction(
    `${PREFIX}/set`,
    (countryID, collections) => ({ countryID, collections })
);
